interface ButtonPropType {
  children: React.ReactNode;
  onClick?: () => void;
  borderColor?: string;
  className?: string;
}

export default function Button({
  children,
  onClick,
  borderColor,
  className,
}: ButtonPropType) {
  return (
    <div
      onClick={onClick}
      className={`w-full h-10 rounded-[40px] text-center text-base font-semibold text-[#111111] border flex items-center justify-center px-11 cursor-pointer ${borderColor} ${className} `}
    >
      <p className="my-2  text-center">{children}</p>
    </div>
  );
}
